import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { ModulesEnum } from '../enum';
import { NavigationService } from '../navigation.service';
/**
 * Side bar navigation component
 */
@Component({
  selector: 'side-bar-navigation',
  templateUrl: './side-bar-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideBarNavigationComponent extends DestroyBase implements OnInit {
  /**
   * Constructor
   * @param navigationService
   * @param ref
   */
  constructor(private navigationService: NavigationService, private ref: ChangeDetectorRef) {
    super();
  }
  /**
   * Active module
   */
  activeModule: ModulesEnum;

  /**
   * The module type
   */
  public get moduleType(): typeof ModulesEnum {
    return ModulesEnum;
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscriptions.add(this.navigationService.activeModule$.subscribe((module: ModulesEnum) => {
      setTimeout(() => {
        this.activeModule = module;
        this.ref.markForCheck();
      });
    }));
  }
}
